import { render, staticRenderFns } from "./EditCourier.vue?vue&type=template&id=6a6ba1a1"
import script from "./EditCourier.vue?vue&type=script&lang=js"
export * from "./EditCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports